export function replaceUnicode(val) {
    if (typeof val === "string") {
        // replaces a microsoft em dash with a unicode em dash
        // see https://doremifaso.ca/archives/unicode/latin1.html
        // and https://doremifaso.ca/archives/unicode/named-entities.html
        return val.replace('\u0097', '\u2014');
    }

    return val;
}